import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import apiService from '../../API/ApiService';

const LoginPage = ({ login }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async () => {
    setIsLoading(true);
    setErrorMessage('');

    try {
      const response = await apiService.get("/getAllUsers");
      if (!response?.data) {
        console.log("response.data " ,response.data)
        throw new Error('Réponse invalide du serveur');
      }
      const userFound = response.data.find(u =>
        (u.email === username ) &&
        u.password === password
      );
      if (userFound) {
        localStorage.setItem('username', username);
        login();
        navigate('/app/tester-interface', { state: { username } });
      } else {
        setErrorMessage('Identifiants incorrects');
      }
    } catch (error) {
       console.log("error is " ,error)
      setErrorMessage(error.response?.data?.message || error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="login-page">
      <div className="login-form">
        <div className="logo">
          <img src="/logo_ds5.png" />
        </div>
        <h2>DS5 Tester</h2>
        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter'){
              handleLogin();
            }
          }}
        />
        <button onClick={handleLogin} disabled={isLoading}>
          {isLoading ? 'Connexion...' : 'Login'}
        </button>
        {errorMessage && <p className="error-message">{errorMessage}</p>}
      </div>

      <footer className="login-footer">
        <p>&copy; {new Date().getFullYear()} DS5. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default LoginPage;